import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { WixCodeSdkHandlersProviderSym } from '@wix/thunderbolt-symbols'
import { ComponentsRegistrarSymbol } from '@wix/thunderbolt-components-loader'
import { ModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import { ComponentWillMountSymbol } from 'feature-components'
import OOISdkHandlersProvider from '../ooiSdkHandlersProvider'
import { ooiComponentWillMount } from './ooiComponentWillMount'
import ReporterFactory, { OOIReporterSymbol, Reporter } from '../reporting'
import { ModuleFederationSharedScopeSymbol, ReactLoaderForOOISymbol } from '../symbols'
import { ooiComponentsRegistrar } from '../ooiComponentsRegistrar'
import viewportWidthProvider, { IViewportWidthProvider, OOIViewportWidthProviderSymbol } from '../viewportWidthProvider'
import { ooiWidgetSideEffectsHandler } from './ooiWidgetSideEffectsHandler'

export const editorPage: ContainerModuleLoader = (bind) => {
	bind(WixCodeSdkHandlersProviderSym).to(OOISdkHandlersProvider)
	bind(ComponentWillMountSymbol).to(ooiComponentWillMount)
}

export const editor: ContainerModuleLoader = (bind) => {
	bind<Reporter>(OOIReporterSymbol).to(ReporterFactory)
	bind(ReactLoaderForOOISymbol).to(require('../client/componentsLoaderClient').default)
	bind(ComponentsRegistrarSymbol).to(ooiComponentsRegistrar)
	bind(ModuleFederationSharedScopeSymbol).toConstantValue({})
	bind(ModelUpdatesHandlersImplementor).to(ooiWidgetSideEffectsHandler)
	bind<IViewportWidthProvider>(OOIViewportWidthProviderSymbol).to(viewportWidthProvider)
}

export * from '../types'
export * from '../symbols'
